import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { CreateFileStorageUseCase } from '../create-file-storage.usecase';
export var CREATE_MARKDOWN_EDITOR_AUDIO_USE_CASE = 'CREATE_MARKDOWN_EDITOR_AUDIO_USE_CASE';
export var CreateMarkdownEditorAudioUseCase = /*#__PURE__*/function (_CreateFileStorageUse) {
  _inherits(CreateMarkdownEditorAudioUseCase, _CreateFileStorageUse);

  var _super = _createSuper(CreateMarkdownEditorAudioUseCase);

  function CreateMarkdownEditorAudioUseCase(fileStorageRepository, externalFileStorageRepository) {
    var _this;

    _classCallCheck(this, CreateMarkdownEditorAudioUseCase);

    _this = _super.call(this, fileStorageRepository, externalFileStorageRepository);
    _this.fileStorageRepository = fileStorageRepository;
    _this.externalFileStorageRepository = externalFileStorageRepository;
    return _this;
  }

  _createClass(CreateMarkdownEditorAudioUseCase, [{
    key: "createFile",
    value: function () {
      var _createFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.fileStorageRepository.createMarkdownEditorAudio(input);

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createFile(_x) {
        return _createFile.apply(this, arguments);
      }

      return createFile;
    }()
  }, {
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.uploadFile(input);

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function buildUseCase(_x2) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return CreateMarkdownEditorAudioUseCase;
}(CreateFileStorageUseCase);